import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import {
  CalendarIcon,
  CheckIcon,
  ChevronRightIcon,
  ExternalLinkIcon,
  MagnifyingGlassIcon,
  SlashIcon,
} from "@radix-ui/react-icons";
import clsx from "clsx";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  ProjectsMilestonesAnalyticsData,
  useGetProjectsMilestonesAnalytics,
} from "src/api/Analytics/project";
import { ProjectsV2FilterGroup } from "src/api/Services/Projects/projects";
import { useGetTaskersForInstance } from "src/api/Services/Tasks/tasks";
import { useGetSpaces } from "src/api/Spaces/spaces";
import { Button } from "src/components/ui/button";
import { Loading } from "src/components/ui/loading";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/components/ui/tooltip";
import { getStatusSymbol } from "src/pages/Services/Tasks/Task";
import {
  addSearchToFilterGroup,
  clean,
  Filter,
  SearchInput,
  StatusFilter,
} from "src/pages/spaces/space/projects";
import { getProjectsMilestonesAnalyticsFilterKey } from "src/utils/filters";

type Props = {};

export default function MilestonesTimelineViewAnalytics({}: Props) {
  const [filterGroup, setFilterGroup] = useState<ProjectsV2FilterGroup>(() => {
    const savedFilterGroup = localStorage.getItem(
      getProjectsMilestonesAnalyticsFilterKey()
    );
    if (savedFilterGroup) {
      return JSON.parse(savedFilterGroup);
    }
    return {
      logic: "AND",
      children: [
        {
          field: "project-status",
          comparator: "in",
          value: ["In Progress"],
        },
      ],
    };
  });
  useEffect(() => {
    if (filterGroup.children.length === 0) {
      localStorage.removeItem(getProjectsMilestonesAnalyticsFilterKey());
    } else {
      localStorage.setItem(
        getProjectsMilestonesAnalyticsFilterKey(),
        JSON.stringify(filterGroup)
      );
    }
  }, [filterGroup]);
  const [search, setSearch] = useState("");
  const [pageNo, setPageNo] = useState(1);
  useEffect(() => {
    setPageNo(1);
  }, [filterGroup, search]);
  const { data: projectsMilestonesAnalytics } =
    useGetProjectsMilestonesAnalytics(
      addSearchToFilterGroup(clean(filterGroup), search),
      pageNo
    );
  const [totalNoOfPages, setTotalNoOfPages] = useState<number | undefined>(
    undefined
  );
  useEffect(() => {
    if (projectsMilestonesAnalytics?.pagination.totalPages === 0) {
      setTotalNoOfPages(1);
    } else if (projectsMilestonesAnalytics?.pagination.totalPages) {
      setTotalNoOfPages(projectsMilestonesAnalytics?.pagination.totalPages);
    }
  }, [projectsMilestonesAnalytics?.pagination.totalPages]);
  const { data: instanceMembers } = useGetTaskersForInstance();
  const { data: spaces } = useGetSpaces();

  return (
    <div className="flex h-full flex-col">
      <div className="flex h-12 items-center border-b border-gray-200/70 px-8 text-sm text-gray-800">
        <div className="flex items-center space-x-2 text-sm">
          <Link to={`/analytics`}>
            <div className="text-gray-800">{"Analytics"}</div>
          </Link>
          <ChevronRightIcon className="h-3 w-3 text-gray-500" />
          <div className="cursor-default text-gray-800">
            {"Project Milestones"}
          </div>
        </div>
      </div>
      <div className="flex h-14 items-center gap-2 border-b border-gray-200/70 px-8">
        {/* <Filter
            filterGroup={filterGroup}
            setFilterGroup={setFilterGroup}
            isLoading={!projectOwners}
            // localStorageKey="project-filter"
            filterModels={[
              {
                field: "project-owner",
                projectOwners:
                  // Array.from(
                  //   new Map(
                  //     projects?.projects.map((p) => [
                  //       p.owner._id,
                  //       {
                  //         _id: p.owner._id,
                  //         name: p.owner.name,
                  //         email: p.owner.email,
                  //       },
                  //     ])
                  //   ).values()
                  // ) ?? [],
                  projectOwners?.map((m) => {
                    return {
                      _id: m._id,
                      name: m.name,
                      email: m.email,
                    };
                  }) ?? [],
              },
              { field: "project-status" },
              { field: "company" },
              {
                field: "project-template",
                projectTemplates:
                  journeyTemplates
                    ?.filter((jt) => jt.spaceId?.toString() === spaceId)
                    .map((jt) => {
                      return {
                        _id: jt._id?.toString() ?? "",
                        name: jt.name,
                      };
                    }) ?? [],
              },
            ]}
          /> */}
        <Filter
          filterGroup={filterGroup}
          setFilterGroup={setFilterGroup}
          isLoading={!instanceMembers}
          // localStorageKey="project-filter"
          filterModels={[
            {
              field: "project-owner",
              projectOwners:
                // Array.from(
                //   new Map(
                //     projects?.projects.map((p) => [
                //       p.owner._id,
                //       {
                //         _id: p.owner._id,
                //         name: p.owner.name,
                //         email: p.owner.email,
                //       },
                //     ])
                //   ).values()
                // ) ?? [],
                instanceMembers?.map((m) => {
                  return {
                    _id: m._id,
                    name: m.name,
                    email: m.email,
                  };
                }) ?? [],
            },
            // { field: "project-status" },
            { field: "company" },
            {
              field: "space",
              spaces:
                spaces
                  // ?.filter((s) => s.settings.timeTracking)
                  ?.map((s) => ({
                    _id: s._id,
                    name: s.name,
                    color: s.color,
                  })) ?? [],
            },
            // {
            //   field: "project-template",
            //   projectTemplates:
            //     journeyTemplates
            //       ?.filter((jt) => jt.spaceId?.toString() === spaceId)
            //       .map((jt) => {
            //         return {
            //           _id: jt._id?.toString() ?? "",
            //           name: jt.name,
            //         };
            //       }) ?? [],
            // },
          ]}
        />
        <StatusFilter
          filterGroup={filterGroup}
          setFilterGroup={setFilterGroup}
        />
        <div className="relative">
          <SearchInput
            onChange={(value) => {
              setSearch(value);
            }}
            initialValue={search}
          />
          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5">
            <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
          </div>
        </div>
        {/* <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5">
            <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
          </div>
        </div> */}
        <div
          className={clsx(
            "flex h-8 items-center space-x-2 overflow-hidden rounded-md border border-input shadow-sm"
            // isLoading && "opacity-50"
          )}
        >
          <div
            className={clsx(
              "flex h-full w-7 items-center justify-center border-r border-input transition-all",
              pageNo === 1
                ? "cursor-not-allowed text-gray-300"
                : "cursor-pointer text-gray-500 hover:bg-gray-50 hover:text-gray-700"
            )}
            onClick={() => {
              if (pageNo === 1) return;
              setPageNo((prev) => prev - 1);
            }}
          >
            <ChevronLeftIcon className="h-4 w-4" />
          </div>
          <div className="flex select-none items-center space-x-1 px-1 text-sm text-gray-600">
            <div className="min-w-[12px] text-center">{pageNo}</div>
            <SlashIcon className="h-3 w-3 text-gray-500" />
            <div className="min-w-[12px] text-center">
              {totalNoOfPages ? (
                totalNoOfPages
              ) : (
                <div className="h-3 w-3 animate-pulse rounded bg-gray-200" />
              )}
            </div>
          </div>
          <div
            className={clsx(
              "flex h-full w-7 items-center justify-center border-l border-input transition-all",
              pageNo === totalNoOfPages
                ? "cursor-not-allowed text-gray-300"
                : "cursor-pointer text-gray-500 hover:bg-gray-50 hover:text-gray-700"
            )}
            onClick={() => {
              if (pageNo === totalNoOfPages) return;
              setPageNo((prev) => prev + 1);
            }}
          >
            <ChevronRightIcon className="h-4 w-4" />
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col overflow-auto">
        {!!projectsMilestonesAnalytics ? (
          <div className="w-full min-w-fit">
            {projectsMilestonesAnalytics?.projects.map((project) => (
              <ProjectRow project={project} key={project._id} />
            ))}
          </div>
        ) : (
          <Loading className="mx-auto mt-[20vh]" />
        )}
      </div>
    </div>
  );
}

function ProjectRow({ project }: { project: ProjectsMilestonesAnalyticsData }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      key={project._id}
      className="group relative flex cursor-pointer items-center border-b border-gray-200/70 hover:bg-gray-50"
      onClick={() => setOpen(!open)}
    >
      <div
        className="sticky inset-y-0 left-0 z-10 flex w-80 shrink-0 items-center space-x-2 truncate border-r border-gray-200/70 bg-white px-8 text-sm group-hover:bg-gray-50"
        style={{
          height: open ? project.milestones.length * 48 + 100 : "160px",
        }}
      >
        <div>{project.name}</div>
        <div className="opacity-0 transition-opacity duration-100 group-hover:opacity-100">
          <Button
            variant={"ghost"}
            className="h-6 w-6 p-0"
            onClick={() => {
              window.open(`/projects/${project._id}`, "_blank");
            }}
          >
            <ExternalLinkIcon className="h-4 w-4" />
          </Button>
        </div>
      </div>
      {!open && (
        <div className="relative flex h-40 min-w-fit flex-1 space-x-8 overflow-auto">
          <div
            style={{
              width: (project.milestones.length + 1) * 272,
            }}
            className="absolute top-16 left-8 h-[1px] -translate-y-1/2 bg-gradient-to-r from-gray-400 to-gray-200"
          />
          <div className="relative w-60 shrink-0">
            <div className="absolute top-[32px] text-sm font-medium">
              Start Date
            </div>
            <div className="absolute top-16 h-2 w-2 -translate-y-1/2 rounded-full bg-gray-400" />
            <div className="absolute top-[76px] text-xs">
              {project.assignedStartDate
                ? dayjs(project.assignedStartDate).format("MMM DD")
                : "N/A"}
            </div>
          </div>
          {project.milestones
            .sort((a, b) => {
              const aDate = a.dueDate || a.expectedCompletionDate;
              const bDate = b.dueDate || b.expectedCompletionDate;
              if (aDate && bDate) {
                return dayjs(aDate).diff(dayjs(bDate));
              }
              if (aDate) {
                return -1;
              }
              if (bDate) {
                return 1;
              }
              return 0;
            })
            .map((m, idx) => (
              <div className="relative w-60 shrink-0">
                <div className="absolute top-[28px] w-full truncate text-sm font-medium">
                  {m.title}
                </div>
                {/* <HoverCard openDelay={50} closeDelay={50}>
                <HoverCardTrigger asChild> */}
                <div
                  className={clsx(
                    "absolute top-16 flex h-4 w-4 -translate-y-1/2 items-center justify-center rounded-full bg-white"
                    // !!m.completionDate &&
                    //   !!m.dueDate &&
                    //   dayjs(m.completionDate).isAfter(dayjs(m.dueDate)) &&
                    //   "border border-red-500 bg-red-100 text-red-500",
                    // !!m.completionDate &&
                    //   !!m.dueDate &&
                    //   dayjs(m.completionDate).isBefore(dayjs(m.dueDate)) &&
                    //   "border border-green-500 bg-green-100 text-green-500",
                    // !m.completionDate && "border border-gray-400 bg-white"
                  )}
                >
                  {m.dueDate ? (
                    getStatusSymbol(m.status)
                  ) : (
                    <div className="h-4 w-4 rounded-full border-[1.5px] border-gray-300" />
                  )}
                  {/* {m.completionDate ? (
                      <CheckIcon className="h-3.5 w-3.5" />
                    ) : (
                      <></>
                      // <div className="h-3.5 w-3.5 rounded-full bg-gray-400" />
                    )} */}
                </div>
                {/* </HoverCardTrigger>
                <HoverCardContent align="center" side="left">
                  <div className="text-sm font-medium">{m.title}</div>
                </HoverCardContent>
              </HoverCard> */}
                <div className="absolute top-[80px] text-xs">
                  <div
                    className={clsx(
                      "flex items-center space-x-1.5 font-light",
                      !m.completionDate &&
                        m.dueDate &&
                        dayjs(m.dueDate).isBefore(dayjs()) &&
                        "text-red-500"
                    )}
                  >
                    <CalendarIcon className="h-3.5 w-3.5" />
                    {m.dueDate ? (
                      <div>{dayjs(m.dueDate).format("MMM DD")}</div>
                    ) : m.expectedCompletionDate ? (
                      <div>
                        {dayjs(m.expectedCompletionDate).format("MMM DD")}
                      </div>
                    ) : (
                      <div>N/A</div>
                    )}
                  </div>
                </div>

                {m.completionDate && (
                  <div
                    className={clsx(
                      "absolute top-[104px] flex items-center space-x-1.5 text-xs",
                      !!m.completionDate &&
                        !!m.dueDate &&
                        dayjs(m.completionDate).isAfter(dayjs(m.dueDate)) &&
                        "text-red-500"
                      // !!m.completionDate &&
                      //   !!m.dueDate &&
                      //   dayjs(m.completionDate).isBefore(dayjs(m.dueDate)) &&
                      //   "text-green-600"
                    )}
                  >
                    <div
                      className={clsx(
                        "flex h-3.5 w-3.5 items-center justify-center rounded-full border",
                        !!m.completionDate && "border-gray-600",
                        !!m.completionDate &&
                          !!m.dueDate &&
                          dayjs(m.completionDate).isAfter(dayjs(m.dueDate)) &&
                          "border-red-500"
                      )}
                    >
                      <CheckIcon className="h-3 w-3" />
                    </div>
                    <div className={"font-light"}>
                      {m.completionDate
                        ? dayjs(m.completionDate).format("MMM DD")
                        : "N/A"}
                    </div>
                  </div>
                )}
                {/* <div className="absolute top-16 left-[-120px]  -translate-y-1/2 rounded-md border border-gray-300 bg-white p-1.5 py-0.5 text-xs">
                {idx > 0 && (
                  <div>
                    {dayjs(m.dueDate).diff(
                      dayjs(project.milestones[idx - 1].dueDate),
                      "day"
                    )}{" "}
                    days
                  </div>
                )}
                {idx === 0 && (
                  <div>
                    {dayjs(m.dueDate).diff(
                      dayjs(project.assignedStartDate),
                      "day"
                    )}{" "}
                    days
                  </div>
                )}
              </div> */}
              </div>
            ))}
          <div className="relative w-60 shrink-0">
            <div className="absolute top-[32px] text-sm font-medium">
              End Date
            </div>
            <div className="absolute top-16 h-2 w-2 -translate-y-1/2 rounded-full bg-gray-400" />
            <div className="absolute top-[76px] text-xs">
              {project.assignedEndDate
                ? dayjs(project.assignedEndDate).format("MMM DD")
                : "N/A"}
            </div>
          </div>
        </div>
      )}
      {open && <ExpandedProjectRow project={project} />}

      {/* <div
        className={clsx(
          "flex flex-1 items-center space-x-8 border-l border-gray-200/70 px-8",
          open ? "h-fit" : "h-32"
        )}
      >
        {!open &&
          project.milestones.map((m) => (
            <div className="flex w-28 flex-col gap-1.5">
              <div className="truncate text-sm text-gray-600">
                {m.name ? m.name : m.task.title}
              </div>
              <div
                className={clsx(
                  "h-3 w-3 rounded-full",
                  !!m.completedAt ? "bg-green-500" : "bg-gray-500"
                )}
              />
              <div className="flex items-center h-4 space-x-1.5 text-sm text-gray-600">
                <CalendarIcon className="h-3.5 w-3.5" />
                <div>{m.dueDate ? dayjs(m.dueDate).format("MMM DD") : ""}</div>
              </div>
              <div className="flex items-center space-x-1.5 h-4 text-sm text-gray-600">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  className="h-3.5 w-3.5"
                >
                  <path d="M8 2v4" />
                  <path d="M16 2v4" />
                  <rect width="18" height="18" x="3" y="4" rx="2" />
                  <path d="M3 10h18" />
                  <path d="m9 16 2 2 4-4" />
                </svg>

                <div>
                  {m.completedAt ? dayjs(m.completedAt).format("MMM DD") : ""}
                </div>
              </div>
            </div>
          ))}
        {open && (
          <div>
            {project.milestones.map((m) => (
              <div className="flex h-16 items-center space-x-2 text-sm text-gray-600">
                <div
                  className={clsx(
                    "h-6 w-6 rounded-full",
                    !!m.completedAt ? "bg-green-500" : "bg-gray-500"
                  )}
                />
                {m.dueDate ? dayjs(m.dueDate).format("MMM DD") : ""}
              </div>
            ))}
          </div>
        )}
      </div> */}
    </div>
  );
}

function ExpandedProjectRow({
  project,
}: {
  project: ProjectsMilestonesAnalyticsData;
}) {
  const baseDate = project.assignedStartDate || project.createdAt;
  const milestoneDaysMap = useMemo(() => {
    const milestoneDaysMap: Record<string, number> = {};
    for (const m of project.milestones) {
      const mDate = m.completionDate || m.expectedCompletionDate;
      if (mDate) {
        milestoneDaysMap[String(m._id)] = dayjs(mDate).diff(
          dayjs(baseDate),
          "day"
        );
      }
    }
    return milestoneDaysMap;
  }, [project]);

  const longestMilestoneInDays: number = useMemo(() => {
    return Math.max(...Object.values(milestoneDaysMap));
  }, [milestoneDaysMap]);

  return (
    <div className="w-[600px] pl-8">
      <div>
        <div className="pb-3 text-sm font-medium">
          Project Start Date to Milestone Completion (or Expected Completion)
          Date
        </div>
        {project.milestones.length === 0 && (
          <div className="text-sm text-gray-600">
            This project doesn't have any milestones.
          </div>
        )}
        {project.milestones.map((m) => (
          <div className="flex h-12 items-center gap-6 text-sm text-gray-600">
            <div className="w-40 truncate">{m.title}</div>
            {milestoneDaysMap[String(m._id)] > 0 ? (
              <div className="relative flex flex-1 items-center">
                <div
                  style={{
                    width: `${
                      20 +
                      (milestoneDaysMap[String(m._id)] /
                        longestMilestoneInDays) *
                        60
                    }%`,
                  }}
                  className="h-[1px] bg-gray-400"
                />
                {m.dueDate ? (
                  getStatusSymbol(m.status)
                ) : (
                  <div className="h-4 w-4 rounded-full border-[1.5px] border-gray-300" />
                )}
                <div className="absolute left-4 top-1/2 -translate-y-1/2 rounded-md border border-gray-300 bg-white py-0.5 px-2 text-xs">
                  {milestoneDaysMap[String(m._id)]} days
                </div>
              </div>
            ) : (
              <div className="flex items-center">
                <div className="h-[1px] w-4 bg-gray-400" />
                <div className="flex items-center rounded-md border border-gray-300 bg-white py-0.5 px-2 text-xs">
                  {milestoneDaysMap[String(m._id)]} days{" "}
                  <TooltipProvider>
                    <Tooltip delayDuration={0}>
                      <TooltipTrigger>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="ml-1 h-3.5 w-3.5 text-gray-600"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" x2="12" y1="8" y2="12" />
                          <line x1="12" x2="12.01" y1="16" y2="16" />
                        </svg>
                      </TooltipTrigger>
                      <TooltipContent sideOffset={6}>
                        <div>
                          {m.completionDate ? (
                            <span>
                              The milestone was completed before the start date
                              of the project
                            </span>
                          ) : (
                            <span>
                              The milestone is scheduled to be completed before
                              the start date of the project.
                            </span>
                          )}
                        </div>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
                <div className="h-[1px] w-4 bg-gray-400" />
                {m.dueDate ? (
                  getStatusSymbol(m.status)
                ) : (
                  <div className="h-4 w-4 rounded-full border-[1.5px] border-gray-300" />
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
